import { render, staticRenderFns } from "./AggregateForeman.vue?vue&type=template&id=70f6847a"
import script from "./AggregateForeman.vue?vue&type=script&lang=js"
export * from "./AggregateForeman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports